import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// Global workspace scope every screen reads from.
//   'fleet'      → all-tenant aggregate (MSP portfolio view)
//   '<tenantId>' → single-tenant view (internal tenants.id)
export type Scope = 'fleet' | string

interface ScopeState {
  scope: Scope
  setScope: (scope: Scope) => void
}

export const useScopeStore = create<ScopeState>()(
  persist(
    (set) => ({
      scope: 'fleet',
      setScope: (scope) => set({ scope }),
    }),
    { name: 'msp-secops-scope' }
  )
)
